import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=df3ec5c0&"
import script from "./SocialLogin.vue?vue&type=script&lang=js&"
export * from "./SocialLogin.vue?vue&type=script&lang=js&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SocialLogin.vue"
export default component.exports